<template>
  <div class="grid grid-cols-2 gap-y-6 gap-x-4">
    <div class="text-sm/6 font-medium">
      {{ t('guests.pets') }}
    </div>
    <div
      class="justify-self-end"
     
    >
      <TToggle
        v-model="petsInternal"
        size="sm"
        @update:model-value="updatePets"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  pets: boolean
}>()

const emit = defineEmits<{
  'update:pets': [value: boolean]
}>()

const { t } = useI18n()

const petsInternal = ref(props.pets)

function updatePets() {
  emit('update:pets', petsInternal.value)
}
</script>

<i18n src="~~/i18n/locales/common/search/form/guests.json" lang="json" />
